import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { Session } from 'next-auth';
import { SessionProvider, useSession } from 'next-auth/react';
import { env } from 'lib/env';

type AuthProps = {
  session?: Session;
  skipAuthCheck?: boolean;
};

export const AuthImp: React.FC = ({ children }) => {
  useSession({ required: false });

  return <>{children}</>;
};

export const Auth: React.FC<AuthProps> = ({ children, session, skipAuthCheck }) => {
  const sitecoreContext = useSitecoreContext();
  const skipAuthentication = env.SKIP_AUTHENTICATION;
  if (skipAuthentication) return <>{children}</>;
  const pageState = sitecoreContext.sitecoreContext.pageState;
  // Don't use when in Sitecore since it'll fail
  if (pageState === 'normal' && !skipAuthCheck) {
    return (
      <SessionProvider session={session}>
        <AuthImp>{children}</AuthImp>
      </SessionProvider>
    );
  }
  return <SessionProvider session={session}>{children}</SessionProvider>;
};
